















import { Component, Prop, Vue } from "vue-property-decorator";
import { DataTableHeader } from "vuetify/types/index";
import { SortWarekiDate } from "#/utility/appSort";
import ItemTable from "#/components/ItemTable.vue";
import { LimitCertItems } from "./type";

@Component({
  components: {
    ItemTable
  }
})
export default class LimitCert extends Vue {
  /** 利用者ID */
  @Prop({ default: 0 }) private patientId!: number;

  /** 限度額適用認定証 */
  @Prop({ default: () => [] }) private readonly items!: LimitCertItems[];

  /** 職員権限区分 0:一般職員 1:一般職員以外（一般職員は新規作成、修正、コピー等の編集ができない）*/
  @Prop({ default: 0 }) private readonly authDiv!: number;

  /** 限度額適用認定証ヘッダー */
  private limitCertItemsHeaders: DataTableHeader[] = [
    {
      text: "編集",
      value: "regist",
      sortable: false,
      width: "7.5rem",
      class: "px-1",
      cellClass: "px-1",
      align: "center"
    },
    {
      text: "認定証の種類",
      value: "cert_div_name",
      width: "9rem"
    },
    {
      text: "開始日",
      value: "start_date_wareki",
      width: "158px",
      sort: SortWarekiDate
    },
    {
      text: "終了日",
      value: "end_date_wareki",
      width: "158px",
      sort: SortWarekiDate
    },
    { text: "適用区分", value: "limit_div_text", width: "120px" }
  ];

  /** 新規作成 */
  private limitCertItemsCreate() {
    this.$router.push({
      name: "InsuranceInfoLimitCert",
      params: { id: String(this.patientId), inslimitcertid: "0" }
    });
  }

  /** 修正 */
  private limitCertItemsRepair(item: LimitCertItems) {
    this.$router.push({
      name: "InsuranceInfoLimitCert",
      params: { id: String(this.patientId), inslimitcertid: String(item.id) }
    });
  }

  /** コピー */
  private limitCertItemsCopy(item: LimitCertItems) {
    this.$router.push({
      name: "InsuranceInfoLimitCert",
      params: { id: String(this.patientId), inslimitcertid: String(item.id) },
      query: { mode: "copy" }
    });
  }

  /** 現在有効な限度額適用認定証に色を付ける */
  private limitCertItemsItemsRowBackground(item: LimitCertItems) {
    return item.effective == true ? "green lighten-4" : "";
  }
}
